<template>
  <div :class="'flex flex-col items-center justify-center'">
    <div :class="headerClass">
      <p :class="'text-lg font-bold my-4 text-xl text-center'">
        We're sorry! We are not able to offer you a loan at this time.
      </p>
      <p :class="'text-lg font-light my-4 text-center'">{{ blockedReasonText }}</p>
      <img
        alt="img"
        :src="require('@/assets/img/sketches/rejection_image.svg')"
        class="md:w-1/5 my-4"
      />
      <p :class="'my-4 text-center text-lg'">
        In the meantime, you may explore other sites to find a loan offer that works for you.
      </p>
      <button
        @click="updateTimestampAndRouteToQuinstreet()"
        class="w-310 btn base-button btn-primary p-2 rounded my-4"
      >
        Explore Other Loan Options
      </button>
      <router-link to="/" class="w-310 btn base-button btn-primary-two p-2 rounded my-4"
        >Return to Homepage</router-link
      >
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
export default {
  name: 'ApplicationBlocked',
  data() {
    return {
      state: ''
    }
  },
  mounted() {
    this.state = this.$store.getters.loanState
  },
  methods: {
    updateTimestampAndRouteToQuinstreet() {
      this.loading = true
      this.$apiClient
        .mutate({
          mutation: gql(
            `mutation { addQuinstreetTimestamp(username: "${this.$store.getters.username}") }`
          )
        })
        .then(({ data }) => {
          console.log(data)
        })
        .catch((e) => {
          console.log(e)
          console.log(`FE Error in updateQuinstreetTimestamp: ${e}`)
        })
        .finally(() => {
          this.loading = false
          const link = this.getExternalLoanLink()
          window.location.href = link
        })
    },
    getExternalLoanLink() {
      /**
       * This is a computed because in the future we might add
       * specific params to customize the loan links for users
       */
      return 'http://o1.qnsr.com/cgi/r?;n=203;c=1681890;s=32978;x=7936;f=202301031132330;u=j;z=TIMESTAMP;AFFID=appBlocked'
    }
  },
  computed: {
    blockedReasonText() {
      let text
      if (this.state && this.state.toLowerCase().includes('employer')) {
        text =
          'We regret to inform you that we are not able to offer you a loan at this time. We are constantly working to expand our offerings, and we will notify you when new offers become available that you may be eligible for. We appreciate your interest and hope to serve you in the future.'
      } else {
        text =
          'We are unable to offer you a loan at this time because VIVA is not licensed in your state. We hope to serve you in the near future!'
      }
      return text
    },
    headerClass() {
      let text = 'flex flex-col items-center justify-center p-12 '
      if (!window.location.href.toLowerCase().includes('dashboard')) {
        text += 'bg-white dashboard-card card-shadow '
      }
      return text
    }
  },
  watch: {
    '$store.getters.loanState': function (state) {
      this.state = state
    }
  }
}
</script>
